import { Component, Input } from "@angular/core";
import { DrawerRef } from "@webapp/ui/drawer/abstracts/drawer-ref";
@Component({
  selector: "gh-test-drawer-component",
  templateUrl: "./test-drawer.component.html",
  styleUrls: [],
})
export class TestDrawerComponent {
  @Input()
  public testData!: string;

  public constructor(private drawerRef: DrawerRef<string>) {}

  public close(): void {
    this.drawerRef.close({ randomText: "Return value of our component modal", originalInput: this.testData });
  }
}
